import i18n from 'scoreboard/components/i18n'
import highlight from 'scoreboard/components/highlight'
import SuccessDialog from 'scoreboard/components/success-dialog'

const SendToEmailConfirmation = SuccessDialog.extend({

	initialize: function (options) {
		this.options = options || {}
	},

	context: function () {
		return {
			title: i18n.get('common.export.sendToEmail.emailSent'),
			message: i18n.countMessage('common.export.sendToEmail.confirmation.message',
				 this.options.totalRecipients, // Total for plur/singular choice
				 highlight(this.options.item),
				 this.options.totalRecipients) // Passed into the message
		}
	},

	done: function () {
		this.trigger('done')
	}
})

export default SendToEmailConfirmation
SendToEmailConfirmation.__filename__ = 'components/export/send-to-email-confirmation.js'
